<template>
    <div>
        <header :class="tophide">
            <!-- <div class="main">
		<div class="logo l">
			<img src="/static/images/web/logo.png" alt="">
		</div>
        <div class="nav r logout" v-if="!hideLogin&&info.posterName">
            <a @click="logout">退出</a>
        </div>
        <div class="nav r">
			<a class="menuBtn" :class="{on:locationUrl.indexOf(item.url)>-1}" v-for="(item, index) in menuList" :key="index" @click="page(item.url)">{{item.name}}</a>
			<template v-if="!hideLogin">
				<a class="login" @click="toLogin" v-if="!info.posterName">登录</a>
				<Dropdown transfer>
					<a class="login" target="_blank" v-if="info.posterName">{{info.posterName}}</a>
					<DropdownMenu slot="list">
						<DropdownItem @click.native="toPage('/haierProduct.html#/my/order')">企业团体雇主责任险</DropdownItem>
						<DropdownItem @click.native="toPage('/haierProduct.html#/my/order?product=TRUCK_EMPLOYERS_LIABILITY_INSURANCE')">货车雇主责任险</DropdownItem>
						<DropdownItem @click.native="toPage('/haier.html#/my/order')">海尔经销商防控计划</DropdownItem>
						<DropdownItem @click.native="toPage('/agent.html#/agent/my/task')" v-if="info.isInHaier">原保代产品</DropdownItem>
					</DropdownMenu>
				</Dropdown>
			</template>
        </div>
	</div> -->
            <div class="hmain">
                <div class="logo">
                    <!-- <img v-if="locationUrl.indexOf('qzg001.com')>-1" src="/static/images/common/logo1.png" alt=""> -->
                    <img src="/static/images/common/logo-zm.png" alt="">
                </div>
                <div class="nav" >
                    <a class="menuBtn"
                        :class="{on:(locationUrl.indexOf(item.url)>-1&&locationUrl!='/')||(locationUrl=='/'&&item.url=='/index')}"
                        v-for="(item, index) in menuList" :key="index" @click="toPage(item.url)">{{item.name}}</a>
                    <template v-if="!hideLogin" >
                        <a class="login"   @click="toLogin" v-if="!$store.state.common.info.posterName">登录{{$store.state.common.info.posterName}}</a>
                        <Dropdown trigger="click" transfer>
                            <a class="login" target="_blank"   v-if="$store.state.common.info.posterName">
                                <!-- <Icon type="ios-person"></Icon> -->
			                    <span class="icon"><img style="transform: translateY(5px);" src="/static/images/common/login.png" alt=""></span>
                                {{$store.state.common.info.posterName}}
                            </a>
                            <DropdownMenu slot="list">
                                <Dropdown placement="right-start" transfer>
                                    <DropdownItem>
                                        我的订单
                                        <Icon type="ios-arrow-forward"></Icon>
                                    </DropdownItem>
                                    <DropdownMenu slot="list">
                                        <DropdownItem @click.native="toPage('/haierProduct.html#/my/order')">企业团体雇主责任险</DropdownItem>
                                        <DropdownItem @click.native="toPage('/haierProduct.html#/my/order?product=TRUCK_EMPLOYERS_LIABILITY_INSURANCE')">货车雇主责任险</DropdownItem>
                                        <DropdownItem @click.native="toPage('/haier.html#/my/order')">海尔经销商防控计划</DropdownItem>
                                        <DropdownItem @click.native="toPage('/agent.html#/agent/my/task')"  v-if="$store.state.common.info.isInHaier">原保代产品</DropdownItem>
                                        <DropdownItem @click.native="toPage('/haierProduct.html#/my/customized/task')">建工产品</DropdownItem>
                                        <DropdownItem @click.native="toPage('/haierProduct.html#/my/customizedCCIC/order')">行业小微人资产品</DropdownItem>
                                        <DropdownItem @click.native="toPage('/haierProduct.html#/my/myspcleqpt/order')" v-if="!$store.state.common.info.isInHaier">社会化特三</DropdownItem>
                                    </DropdownMenu>
                                </Dropdown><br />
                                <Dropdown placement="right-start" transfer>
                                    <DropdownItem>
                                        我的保单
                                        <Icon type="ios-arrow-forward"></Icon>
                                    </DropdownItem>
                                    <DropdownMenu slot="list">
                                        <DropdownItem @click.native="toPage('/haierProduct.html#/my/policy')">企业团体雇主责任险</DropdownItem>
                                        <DropdownItem @click.native="toPage('/haierProduct.html#/my/policy?product=TRUCK_EMPLOYERS_LIABILITY_INSURANCE')">货车雇主责任险</DropdownItem>
                                        <DropdownItem @click.native="toPage('/haier.html#/my/policy')">海尔经销商防控计划</DropdownItem>
                                        <DropdownItem @click.native="toPage('/agent.html#/agent/my/policy')"  v-if="$store.state.common.info.isInHaier">原保代产品</DropdownItem>
                                        <DropdownItem @click.native="toPage('/haierProduct.html#/my/customized/policy')">建工产品</DropdownItem>
                                        <DropdownItem @click.native="toPage('/haierProduct.html#/my/customizedCCIC/policy')">行业小微人资产品</DropdownItem>
                                        <DropdownItem @click.native="toPage('/haierProduct.html#/my/customizedTPL/policy')">特种设备责任险</DropdownItem>
                                        <DropdownItem @click.native="toPage('/haierProduct.html#/my/customizedLineWork/policy')">同线工人保险</DropdownItem>
                                        <DropdownItem @click.native="toPage('/haierProduct.html#/my/myspcleqpt/policy')" v-if="!$store.state.common.info.isInHaier">社会化特三</DropdownItem>
                                    </DropdownMenu>
                                </Dropdown><br />
                                <Dropdown placement="right-start" transfer>
                                    <DropdownItem>
                                        账号设置
                                        <Icon type="ios-arrow-forward"></Icon>
                                    </DropdownItem>
                                    <DropdownMenu slot="list">
                                        <DropdownItem @click.native="modal=true">账户安全</DropdownItem>
                                        <DropdownItem @click.native="agreementShow=true">用户协议隐私政策</DropdownItem>
                                        <DropdownItem @click.native="modal=true">撤回同意隐私政策</DropdownItem>
                                        <DropdownItem @click.native="modal=true">注销账户</DropdownItem>
                                    </DropdownMenu>
                                </Dropdown>
                                <DropdownItem @click.native="logout" v-if="!hideLogin&&$store.state.common.info.posterName">退出登录</DropdownItem>
                            </DropdownMenu>
                        </Dropdown>
                    </template>
                    <!-- <a >退出</a> -->
                </div>
            </div>
        </header>
        <div style="height:100px"></div>
        <Modal v-model="modal" title="提示" @on-cancel="modal=false">
            <div>
                <p>请在"全掌柜"APP"我的"-"设置"中操作;或关注"全掌柜"微信公众号,打开"保险商城"在"我的"-"设置"中操作。</p>
                <div class="flex">
                    <p>
                        <img src="/static/images/common/wechat.jpg" alt="">
                        <span>全掌柜微信公众号</span>
                    </p>
                    <p>
                        <img src="/static/images/common/app.jpg" alt="">
                        <span>全掌柜APP</span>
                    </p>
                </div>
            </div>
            <div slot="footer" class="center">
                <Button type="primary" @click="modal = false">我知道了</Button>
            </div>
        </Modal>
        <Modal v-model="agreementShow" footer-hide title="协议和条款" @on-cancel="agreementShow=false">
            <div style="height:100px">
                <a :href="url"   target="_blank">《用户协议》</a>
                <a :href="url1"  target="_blank">《隐私协议》</a>
            </div>
        </Modal>
        <Modal v-model="modelPhoneHaved"  title="提示" @on-cancel="haierLogout" :z-index="9000">
            <div >
                {{modelMsg}}
            </div>
            <div slot="footer" class="center">
                <Button type="primary" @click="haierLogout">确定</Button>
            </div>
        </Modal>
        <Modal v-model="modelbindTip"  title="提示" @on-cancel="haierLogout" :z-index="9000">
            <div >
                员工号对应手机号({{desenPhone( form.phone)}})已绑定其他账号,您可以使用手机号直接登录或将员工号({{form.userName}})与该账号绑定。
            </div>
            <div slot="footer" class="center">
                <Button  @click="haierLogout">取消</Button>
                <Button type="primary" @click="handBind">账号绑定</Button>
            </div>
        </Modal>
        <Modal v-model="modelbind"  title="账号绑定提示" @on-cancel="haierLogout" :z-index="9000">
            <div style="margin-bottom:20px">
                正在将员工号({{form.userName}})与手机号({{desenPhone( form.phone)}})的账号进行绑定
            </div>
            <Form ref="formInline" :model="form" :rules="ruleInline" >
                <div class="tip_code" v-if="isSend">已发送验证码至{{desenPhone( form.phone)}}</div>
                <Row :gutter="20">
                    <Col span="14">
                        <FormItem prop="code">
                            <Input 
                                type="text" 
                                v-model="form.code" 
                                placeholder="验证码" 
                                class="append"
                                :maxlength="6">
                                    
                            </Input>
                        </FormItem>
                    </Col>
                    <Col span="10">
                        <VCode ref="VCode" :type="20" @changeShow="changeShow"  @showSlider="showSliderFunc"    :phone="form.phone" />
                    </Col>
                </Row> 
            </Form>

                
            <div slot="footer" class="center">
                <Button   @click="haierLogout">取消</Button>
                <Button type="primary" @click="handBindConfirm">确定</Button>
            </div>
        </Modal>
        <Modal v-model="showSlider" title="请完成安全验证" width="400px" :mask-closable="false" :z-index="9001">
            <slide-verify
                ref="slideblock"
                :type="20"
                :l="38"
                :r="8"
                :phone="form.phone"
                @success="onSuccess"
                @fail="onFail"
                @refresh="onRefresh"
                :slider-text="sliderText"
                :slider-type="sliderType"
            ></slide-verify>
            <template slot="footer">
                <div></div>
            </template>
        </Modal>
    </div>
</template>
<script>
    import VCode from '@/components/common/VCode'  
    import SlideVerify from "@/components/common/SlideVerify";
    import { mapState } from 'vuex'
    export default {
        components: { VCode ,SlideVerify },
        props: {
            type: {
                default: 'user'// user用户模式，有登录。  static静态页面模式，没有用户信息。 
            }
        },
        data () {
            return { 
                isSend:false,
                eshow: false,
                modelPhoneHaved:false,
                modelbindTip:false,
                modelbind:false,
                validSuccess:false,
                msg:'',
                showSlider:false, 
                sliderText: "向右滑动验证",
                form:{},
				ruleInline: { 
					code: [
						{ required: true, message: '请输入验证码', trigger: 'blur' },
					] 
				},
                tophide: '',
                modal:false,
                agreementShow:false,
                url:window.origin+`/common.html#/aggrementProtocol/1`,
			    url1:window.origin+`/common.html#/aggrementProtocol/2`,
                modelMsg:'',
                sliderType: 'TEXT'
                // menuList:[
                // 	{url:'/index.html',name:'首页'},
                // 	{url:'/haierProduct.html',name:'产品专区'},
                // 	// {url:'/agent.html',name:'海尔专属'},
                // 	{url:'/introduction.html',name:'平台介绍'},
                // 	// {url:'/join.html',name:'合作加盟'},
                // 	{url:'/publicInfo.html',name:'公开信息披露'},
                // 	{url:'/about.html',name:'关于我们'},
                // ]
            }
        },
        computed: {
            ...mapState({
                info: state => state.common.info
            }),
            hideLogin () {
                return this.type == 'static' || (this.$route.meta && this.$route.meta.hideLogin)
            },
            locationUrl () {
                return location.href
            },
            routeUrl () {
                return this.$route.path
            },
            menuList () {
                let list = []
                if (this.info.isInHaier) {
                    list = [
                        { url: '/index.html', name: '首页' },
                        { url: '/company', name: '企业保险' },
                        { url: "https://partner.haierbx.net/", name: "交互平台" },
                        { url: '/agent', name: '海尔专属' },
                        // {url:'/introduction',name:'保险科普'},
                        // {url:'/pro',name:'扫描王Pro'},
                        // {url:'/join.html',name:'合作加盟'},
                        { url: '/publicInfo.html#/', name: '信息披露' },
                        { url: '/about', name: '关于我们' },
                        { url:'/investor/detail/250',name:'投资者关系'}
                    ]
                } else {
                    list = [
                        { url: '/index.html', name: '首页' },
                        { url: '/company', name: '企业保险' },
                        { url: "https://partner.haierbx.net/", name: "交互平台" },
                        // {url:'/introduction',name:'保险科普'},
                        // {url:'/pro',name:'扫描王Pro'},
                        { url: '/publicInfo.html#/', name: '信息披露' },
                        { url: '/about', name: '关于我们' },
                        { url:'/investor/detail/250',name:'投资者关系'}
                    ]
                }
                return list
            }
        },
        mounted () {
            const iamSdk = window.__USERCENTER__
            console.log(iamSdk)
            const config = JSON.parse(process.env.CONFIG)
            console.log(config)
            // 初始化iam sdk
            iamSdk.configUserCenter({
                ssoUrl: window.location.origin.includes('https://') ? 'https://iama.haier.net' :'https://iam-test.haier.net', //统一登录页 生产：https://iama.haier.net  测试：iam-test.haier.net, 末尾请不要带“/”
                clientId: config.CLIENT_ID,//应用的cliendtId或K Code,此内容在iam-admin.haier.net或iam-admin-test.haier.net-应用中心-应用管理-应用配置中获取
                tokenUrl: "pc/user/haier/haierAuthCode", //集成了账号中心提供的后端服务的地址，请使用https。具体地址请询问自己的后台开发
                appId: config.APP_ID,  //飞书appid，用于ihaier环境下使用。开放平台创建应用获取（open.feishu.cn）
                redirectUri: sessionStorage.getItem('backUrl')  || window.location.origin + '/', //业务系统登录成功后重定向的地址，默认此链接
                exitUrl: window.location.origin + '/common.html#/login', //业务系统退出成功后重定向的地址
                tokenStorageKey: "haier-user-center-access-token", // 本地存储token的key，默认为此值
                userInfoStorageKey: "haier-user-center-user-info", // 本地存储userInfo的key，默认为此值
            })
            this.$router.onReady(()=>{
                if (this.$route.query.code && this.$route.query.state) {
                    this.$axios.get('/user/haier/haierAuthCode.all', { code: this.$route.query.code }).then(res => { 
                       console.log('res',res)
                        if (res.resultCode == 0) {
                            this.getInfo()
                            window.location.href = sessionStorage.getItem('backUrl')
                        } else if(res.resultCode ==10000126 ){ 
                            let result=res.data
                            console.log('result',result)
                            localStorage.setItem('isFresh',1)
                            this.$set(this.form,'phone',result.phone) 
                            this.$set(this.form,'userName',result.account.userName) 
                            this.form.validateCode=result.validateCode
                            this.modelbindTip=true  
                        }else if(res.resultCode ==10000032 ){ 
                            this.modelMsg=res.resultMsg
                            this.modelPhoneHaved=true
                            localStorage.setItem('isFresh',1)

                        }
                        else {
                            if(localStorage.getItem('isFresh')==1) return
                            this.$emit('loaded')
                            this.toast(res.resultMsg || '登录失败', 'error');
                            window.location.href = window.location.origin + '/common.html#/login?bankUrl=' + encodeURIComponent(sessionStorage.getItem('backUrl'));
                        }
                    })
                } else {
                    if (!this.hideLogin) {
                        this.getInfo();
                    }else{
                        this.$emit('loaded')
                    }
                }
            })
        },
        methods: {
            handBind(){
                this.modelbindTip=false
                this.modelbind=true 
                localStorage.removeItem('isFresh')
            },
            handBindConfirm(){
				this.$refs.formInline.validate(valid=>{
					if(valid){
                        this.$axios.post('/user/haierAuthBandPhone',{
                            code:this.form.code,
                            phone:this.form.phone,
                            validateCode:this.form.validateCode,
                        }).then(res=>{ 
                            this.getInfo()
                            this.modelbind=false
                            window.location.href = sessionStorage.getItem('backUrl')
                        })
					}
				})
            },
            page (url) {
                if (url == '/index.html') url = '/'
                location.href = url
            },
            getInfo () {
                this.$axios.post('/user/queryHomePage.all').then(res => {
                    if (res.code == 10000000) {
                        this.$store.commit('setUserInfoAll', res.data)
                    } else {
                        this.$store.commit('setUserInfoAll', {})
                    } 
                    console.log('$store.state.common.info.posterName',this.$store.state.common.info.posterName)
                    this.$emit('loaded')
                });
            },
            toLogin () {
                if (this.$route.name != 'login') {
                    window.location = location.origin + '/common.html#/login?bankUrl=' + encodeURIComponent(location.href);
                }
            },
            logout () {
                this.$axios.post('/user/exit').then(async (res) => {
                    this.$store.commit('setUserInfoAll', {})
                    if(localStorage.getItem('loginType') == 'haier'){
                        localStorage.removeItem('loginType')
                        const config = JSON.parse(process.env.CONFIG)
                        console.log(config)
                        const iamSdk = window.__USERCENTER__
                        iamSdk.configUserCenter({
                            ssoUrl: window.location.origin.includes('https://') ? 'https://iama.haier.net' : 'https://iam-test.haier.net', //统一登录页 生产：https://iama.haier.net  测试：iam-test.haier.net, 末尾请不要带“/”
                            clientId: config.CLIENT_ID,//应用的cliendtId或K Code,此内容在iam-admin.haier.net或iam-admin-test.haier.net-应用中心-应用管理-应用配置中获取
                            tokenUrl: "pc/user/haier/haierAuthCode", //集成了账号中心提供的后端服务的地址，请使用https。具体地址请询问自己的后台开发
                            appId: config.APP_ID,  //飞书appid，用于ihaier环境下使用。开放平台创建应用获取（open.feishu.cn）
                            redirectUri: window.location.origin + '/', //业务系统登录成功后重定向的地址，默认此链接
                            exitUrl: location.href, //业务系统退出成功后重定向的地址
                            tokenStorageKey: "haier-user-center-access-token", // 本地存储token的key，默认为此值
                            userInfoStorageKey: "haier-user-center-user-info", // 本地存储userInfo的key，默认为此值
                            // clearUrlParamCode: false
                        })
                        await iamSdk.logout()
                    }else{
                        window.location.reload();
                    }
                });
            },
            async haierLogout(){
                localStorage.removeItem('isFresh')
                localStorage.removeItem('loginType')
                const iamSdk = window.__USERCENTER__
                const config = JSON.parse(process.env.CONFIG)
                iamSdk.configUserCenter({
                    ssoUrl: window.location.origin.includes('https://') ? 'https://iama.haier.net' : 'https://iam-test.haier.net', //统一登录页 生产：https://iama.haier.net  测试：iam-test.haier.net, 末尾请不要带“/”
                    clientId: "S01314",//应用的cliendtId或K Code,此内容在iam-admin.haier.net或iam-admin-test.haier.net-应用中心-应用管理-应用配置中获取
                    tokenUrl: "pc/user/haier/haierAuthCode", //集成了账号中心提供的后端服务的地址，请使用https。具体地址请询问自己的后台开发
                    appId: "cli_a8b40377c57e900d",  //飞书appid，用于ihaier环境下使用。开放平台创建应用获取（open.feishu.cn）
                    redirectUri: window.location.origin + '/', //业务系统登录成功后重定向的地址，默认此链接
                    exitUrl: location.href, //业务系统退出成功后重定向的地址
                    tokenStorageKey: "haier-user-center-access-token", // 本地存储token的key，默认为此值
                    userInfoStorageKey: "haier-user-center-user-info", // 本地存储userInfo的key，默认为此值
                    // clearUrlParamCode: false
                })
                await iamSdk.logout()
            },
            showSliderFunc(type) {
                if (this.form.phone == '' || !this.rules.tel.test(this.form.phone)) {
                    this.toast('手机号码格式不正确', 'error');
                    return
                }
                this.showSlider = true;
                this.sliderType = type;
                this.$nextTick(() => {
                    if (this.$refs.slideblock) {
                        this.$refs.slideblock.reset()
                       
                    }
                })
            },
            changeShow(){
                this.isSend=false
            },
            onFail() {
                this.validSuccess = false;
            },
            onRefresh() {
                this.msg = "";
            },
            onSuccess() {
                this.validSuccess = true;
                let that = this
                setTimeout(() => {
                    that.showSlider = false;
                    that.$nextTick(() => {
                        if(this.eshow && this.tabName == '1'){
                            that.$refs.EVCode.showTime();
                        }else{
                            if (this.sliderType == 'TEXT') {
                                that.$refs.VCode.showTime();
                            }
                            this.isSend=true
                        }
                    })
                }, 500)
            },
            desenPhone(phone) { 
                if(!phone) return ''
                const desensitized = phone.substr(0, 3) + '****'+ phone.substring(phone.length - 4);  
                return desensitized;  
            },
            toPage (url) {
                if (url == '/index.html') url = '/';
                window.open(url)
            }
        }
    }
</script>
<style lang="less">
    header {
        height: 100px;
        background: #fff;
        position: fixed;
        top: 0;
        width: 100%;
        z-index: 9999999;
        z-index: 1000;
        transition: all .5s;
        box-shadow: 0px 5px 20px 0px rgba(1, 1, 1, 0.1);

        .hmain {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 1200px;
            margin: auto;
        }
    }

    header.touming {
        background: rgba(0, 0, 0, 0.1);

        .nav a {
            color: #fff;
        }

        .nav a.on,
        .nav .menuBtn:hover {
            color: #fff;
        }
    }

    .logo {
        width: 160px;
        img{
            width: 100%;
        }
        // margin-top: 16px;
    }

    .nav {
        height: 100px;
        text-align: right;
    }

    .nav a {
        display: inline-block;
        height: 100%;
        line-height: 100px;
        text-align: center;
        margin: 0 15px;
        cursor: pointer;
        font-size: 18px;
        color: #595959;
        transition: all 0.5s;

        &.menuBtn {
            -webkit-transition: all .3s;
            transition: all .3s;
        }

        &.login {
            margin: 0;
            padding-right: 15px;
            padding-left: 10px;
            width: auto;
            color: #2d8cf0;
        }
    }

    .nav a:last-child {
        margin-right: 0;
    }

    .nav a.on,
    .nav .menuBtn:hover {
        font-weight: 600;
        color: #262626;
    }

    .nav>a.login:hover {
        border-bottom: 0;
    }

    .nav.logout>a {
        width: 50px;
        margin-left: 0;
        text-decoration: none;
        color: #2d8cf0;
    }
    .flex{
        width: 100%;
        display: flex;
        align-items: center;
		justify-content: center;
		p{
			margin-right: 30px;
			display: flex;
			flex-direction: column;
			justify-content: center;
			img{
				width:140px;
			}
			span{
				text-align: center;
			}
		}
    }
</style>


// WEBPACK FOOTER //
// src/components/common/WebHeader.vue